import {useLocation} from "react-router-dom";
import React from "react";
import PageTitleSlim from "../../components/PageTitleSlim/PageTitleSlim";
import SectionTitle from "../../components/SectionTitle/SectionTitle";
import "../RedirectHint/RedirectHintPage.css";

const ErrorPage = () => {
    const location = useLocation();
    const errorMessage = location.state?.message || "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.";
    const errorStatus = location.state?.status || 500;
    const astorId = location.state?.astorId || null;
    const showOnbLinks = location.state?.showOnbLinks || false;
    const showContact = location.state?.showContact || false;

    return (
        <div className="redirect-hint-page">
            <main className="main-content">
                <PageTitleSlim title={`Fehler ${errorStatus}`}/>
                <section className="section-inner">
                    <SectionTitle title={`Ups...ein ${errorStatus} Fehler`}/>
                    <div className="form-container">
                        <h3>{errorMessage}</h3>
                        {astorId && (
                            <>
                                <hr/>
                                <p>
                                    Zurück zum <a href={`https://onb.digital/result/${astorId}`}>digitalisierten
                                    Objekt</a>
                                </p>
                            </>
                        )}
                        {
                            showOnbLinks &&
                            <>
                                <hr/>
                                <p>
                                    Hier gelangen Sie zu den digitalisierten Objekten der Österreichischen
                                    Nationalbibliothek:{" "}
                                    <a href="https://onb.digital">onb.digital</a>
                                </p>
                                <p>
                                    Hier gelagen Sie zum <a href="https://search.onb.ac.at">Katalog</a>
                                </p>
                            </>
                        }
                        {
                            showContact &&
                            <>
                                <hr/>
                                <p>
                                    Sollte es wiederholt zu Problemen kommen, wenden Sie sich bitte an digital@onb.ac.at
                                </p>
                            </>
                        }

                    </div>
                </section>
            </main>
        </div>
    );
};

export default ErrorPage;
